import {StepTypeRect} from '@blesk-frontend/api';
import chroma from 'chroma-js';
import {BORDER_WIDTH, CIRCLE_SIZE} from './consts';

/**
 *
 * @param ctx
 * @param rect
 * @param cursorImage
 */
export const drawRect = (
  ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
  rect: StepTypeRect,
  cursorImage?: HTMLImageElement | OffscreenCanvas,
) => {
  const strokeColor = rect.color || '#e43897';
  const fill = chroma(strokeColor).alpha(0.1).hex();

  ctx.beginPath();
  ctx.strokeStyle = strokeColor;
  ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';
  ctx.shadowBlur = 5;
  ctx.lineWidth = BORDER_WIDTH;
  ctx.fillStyle = fill;

  if (rect.type === 'circle') {
    ctx.arc(rect.x, rect.y, CIRCLE_SIZE / 2 + BORDER_WIDTH * 2, 0, 2 * Math.PI);
  } else {
    ctx.roundRect(rect.x, rect.y, rect.width, rect.height, 4);
  }

  ctx.fill();

  if (rect.type === 'circle' && cursorImage) {
    ctx.drawImage(cursorImage, rect.x - 14, rect.y - 14, 28, 28);
  }

  ctx.stroke();
};
